<template>
    <!-- 添加banner -->
    <content-view>
        <div class="addBanner">
            <a-form :form="form" >
                <a-form-item label="适用模块" :labelCol="labelCol" :wrapperCol="wrapperCol" required >
                    <a-radio-group :disabled="isDisable" @change="onChangeBannerType"
                    v-decorator="['bannerType', {initialValue: $route.query.type}, {rules: [{required: true, message: '请选择内部跳转类型',}]}]">
                        <a-radio :value="'header'">首页头图</a-radio>
                        <a-radio :value="'banner'">首页banner</a-radio>
                    </a-radio-group>
                    <div class="banner-box">
                        <img :preview="true" @click="toPreview" :src="examImg[imgType]" />
                    </div>
                </a-form-item>
                <a-form-item label="上传图片" :labelCol="labelCol" :wrapperCol="wrapperCol" :required="true">
                    <image-uploader ref="uploader" :specialText="specialText" :disabled="isDisable" :value="imgUrl" @uploaded="uploaded"></image-uploader>
                </a-form-item>
                <a-form-item label="适用门店" :labelCol="labelCol" :wrapperCol="wrapperCol" required >
                    <a-select
                    :disabled="isDisable"
                    placeholder="请选择门店"
                    v-decorator="['shopId',{rules: [{required: true, message: '请选择'}]}]"
                    >
                        <a-select-option :value="item.id" v-for="item in shopList" :key="item.id">{{item.name}}</a-select-option>
                    </a-select>
                </a-form-item>
                <a-form-item label="链接类型" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-radio-group :disabled="isDisable" @change="onChange" v-decorator="['linkType', {initialValue: 1}]" >
                        <a-radio :value="1">链接</a-radio>
                        <a-radio :value="2">站内跳转</a-radio>
                        <a-radio :value="3">无</a-radio>
                    </a-radio-group>
                </a-form-item>
                <a-form-item v-if="linkType == 1" label="链接地址" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-input :disabled="isDisable" placeholder="点击图片链接至" v-decorator="['linkUrl', {rules: [{required: linkType == 1, message: '请输入链接地址'}]}]"/>
                </a-form-item>
                <a-form-item v-show="linkType==2" label="内部跳转" :labelCol="labelCol" :wrapperCol="wrapperCol" >
                    <a-radio-group :disabled="isDisable" @change="onChangeTable"
                    v-decorator="['innerLinkType', {initialValue: 2}, {rules: [{required: true, message: '请选择内部跳转类型',}]}]">
<!--                        <a-radio :value="1">活动资讯</a-radio>-->
                        <a-radio :value="2">票券详情</a-radio>
                        <a-radio :value="3">小程序页面</a-radio>
                    </a-radio-group>
                </a-form-item>
                <a-form-item v-show="linkType == 2 && showTable == 'news'" label="活动资讯" :labelCol="labelCol" :wrapperCol="{span: 14}" >
                    <a-table :scroll="{y:500}" bordered :dataSource="dataSourceNews" :columns="columnsNews" :pagination="false" :rowKey="record => record.id">
                        <span slot="action" slot-scope="a, row">
                            <a-radio style="width:30px" :disabled="isDisable" :checked="row.checked" @click="linkNews(row.id)">{{row.checked ? '已关联' : '关联'}}</a-radio>
                        </span>
                    </a-table>
                </a-form-item>
                <a-form-item v-show="linkType == 2 && showTable == 'tickets'" label="票券详情" :labelCol="labelCol" :wrapperCol="{span: 14}" >
                    <a-table :scroll="{y:500}" bordered :dataSource="dataSourceTicket" :columns="columnsTicket" :pagination="false" :rowKey="record => record.ticketTemplateId">
                        <span slot="action" slot-scope="a, row">
                            <a-radio style="width:30px" :disabled="isDisable" :checked="row.checked" @click="linkTicket(row.ticketTemplateId)">{{row.checked ? '已关联' : '关联'}}</a-radio>
                        </span>
                    </a-table>
                </a-form-item>
                <a-form-item v-if="linkType== 2 && showTable == 'link'" label="链接地址" :labelCol="labelCol" :wrapperCol="wrapperCol" >
                    <a-input :disabled="isDisable" placeholder="具体页面地址请联系系统管理员" v-decorator="['linkUrl',{rules: [{required: linkType == 2 && showTable == 'link', message: '请输入链接地址',}]}]"/>
                </a-form-item>
                <a-form-item label="开始展示时间" :labelCol="labelCol" :wrapperCol="wrapperCol" required >
                    <a-date-picker :disabled="isDisable" show-time placeholder="请选择" v-decorator="['effectiveStart', {rules: [{required: true, message: '请选择开始开始时间'}]}]" />
                </a-form-item>
                <a-form-item label="结束展示时间" :labelCol="labelCol" :wrapperCol="wrapperCol" required >
                    <a-radio-group :disabled="isDisable" @change="onChangeTime"
                    v-decorator="['endLabel', {initialValue: 0}]">
                        <a-radio :value="0">暂不设置</a-radio>
                        <a-radio :value="1">定时结束展示</a-radio>
                    </a-radio-group>
                </a-form-item>
                <a-form-item :required="false" v-show="form.getFieldValue('endLabel') == 1" label=" " :colon="false"  :labelCol="labelCol" :wrapperCol="wrapperCol" >
                    <a-date-picker show-time placeholder="请选择" v-decorator="['effectiveEnd', {rules: [{required: form.getFieldValue('endLabel') == 1, message: '请选择定时结束时间'}]}]" />
                </a-form-item>
                <a-form-item class="text-center">
                    <a-button @click="backStep">返回</a-button>
                    <a-button type="primary" @click="handleSubmit" v-if="!isDisable" >保存</a-button>
                </a-form-item>
            </a-form>
        </div>
    </content-view>
</template>

<script type="text/javascript">
    import ImageUploader from '@/components/common/image-uploader.component';
    const examImg = {
            bannerLager: 'https://apailang.oss-cn-hangzhou.aliyuncs.com/images/20221130/1669788412602_backImage',
            bannerSmall: 'https://apailang.oss-cn-hangzhou.aliyuncs.com/images/20221130/1669789231784_backImage',
            headerLager: 'https://apailang.oss-cn-hangzhou.aliyuncs.com/images/20221130/1669789066744_backImage',
            headerSmall: 'https://apailang.oss-cn-hangzhou.aliyuncs.com/images/20221130/1669789257344_backImage',
        }

    // 资讯
    const columnsNews = [
    {
        title: "资讯编号",
        dataIndex: "id",
        width: 100,
    },
    {
        title: "资讯名称",
        dataIndex: "title",
        width: 400,
    },
    {
        title: "操作",
        key: "action",
        width: 120,
        scopedSlots: { customRender: "action" }
    }];
    // 票券
    const columnsTicket = [
    {
        title: "票券编号",
        dataIndex: "ticketTemplateId",
        width: 80,
    },
    {
        title: "票券内部标识",
        dataIndex: "name",
        width: 220,
    },
    {
        title: "票券展示名称",
        dataIndex: "showName",
        width: 220,
    },
    {
        title: "操作",
        key: "action",
        width: 130,
        scopedSlots: { customRender: "action" }
    }];
    export default {
        name: "addBanner",
        components: {
            ImageUploader
        },
        props: {},
        data() {
            return {
                labelCol: {span: 8},
                wrapperCol: {span: 8},
                columnsNews,
                dataSourceNews: [],
                columnsTicket,
                dataSourceTicket: [],
                showTable: 'tickets',
                isDisable: false,
                imgUrl: "",
                linkType: 1,
                id: '',
                examImg,
                imgType: 'headerSmall',
                specialText: '尺寸等于1125px*957px',
                shopList: []
            };
        },
        methods: {
            // 获取APP资讯列表数据
            getListNews() {
                this.$api.operation.newsList({
                    body: {
                        isEnable: true,
                        pageNum: 1,
                        pageSize: 999999
                    }
                }).then(res => {
                    res.list.forEach((item) => {
                        item.checked = false;
                    })
                    this.dataSourceNews = res.list;
                });
            },
            // 系统店铺获取
            getShopList() {
                this.$api.totalPlatform.selectList({}).then(res => {
                    res.forEach(el => {
                        el.label = el.name;
                        el.value = el.id;
                        el.id = el.id;
                        el.suitRetail = [];
                    });
                    this.shopList = res;
                });
            },

            // 获取票券列表数据
            getListTicket() {
                this.$api.totalPlatform.ticketSelectList(
                    {
                        body: {
                            isOnShelves: true,
                            isMiniSell: true,
                            pageSize: 999,
                            pageNum: 1,
                        }
                    }
                ).then(res => {
                    if (res && res.list) {
                        res.list.forEach((item) => {
                            item.checked = false
                        })
                        this.dataSourceTicket = res.list;
                    }
                });
            },

            // 只能关联单个资讯
            linkNews(id) {
                this.dataSourceNews.forEach(item => {
                    item.checked = false;
                    if(item.id === id) {
                        item.checked = true;
                    }
                })
            },

            // 只能关联单个票券
            linkTicket(id) {
                this.dataSourceTicket.forEach(item => {
                    item.checked = false;
                    if(item.ticketTemplateId == id && !item.checked) {
                        item.checked = true;
                    }
                })
            },
            // 提交保存
            handleSubmit() {
                this.form.validateFields((errors, values) => {
                    if (!Boolean(this.imgUrl)) {
                        this.$message.error('请上传图片！');
                        return false;
                    }
                    if (Boolean(errors)) {
                        return false;
                    }
                    values.imgUrl = this.imgUrl;
                    if(values.innerLinkType === 1) { // 活动资讯
                        let checkedNews = this.dataSourceNews.find(i => i.checked);
                        if (checkedNews) {
                            values.newsId = checkedNews.id;
                        }
                    }else if(values.innerLinkType === 2) { // 票券详情
                        let checkedTicket = this.dataSourceTicket.find(i => i.checked);
                        if (checkedTicket) {
                            values.ticketId = checkedTicket.ticketTemplateId;
                        }
                    }
                    if (values.linkType === 1) {
                        delete values.innerLinkType;
                    }
                    if (values.innerLinkType === 1 || values.innerLinkType === 2) {
                        values.linkUrl = '';
                    }
                    if(values.endLabel == 1 && this.$moment(values.effectiveEnd) - this.$moment(values.effectiveStart) <= 0) {
                        this.$message.warning('结束展示时间不能早于开始展示时间')
                        return
                    }
                    values.effectiveStart = this.$moment(values.effectiveStart).format('YYYY-MM-DD HH:mm:ss');
                    values.effectiveEnd = values.endLabel == 1 ? this.$moment(values.effectiveEnd).format('YYYY-MM-DD HH:mm:ss') : null;
                    delete values.endLabel
                    if(this.$route.name == 'addBanner') { // 新增
                        this.addBanner(values);
                    }else { // 编辑
                        this.updateBanner(values);
                    }
                });
            },
            // 获取详情
            detailBanner() {
                this.$api.operation.detailBanner({
                    params: {id: this.id}
                }).then(res => {
                    this.imgUrl = res.imgUrl;
                    this.linkType = res.linkType;
                    this.showTable = Boolean(res.innerLinkType) ? res.innerLinkType == 2 ? 'tickets' : res.innerLinkType == 1 ? 'news' : 'link' : 'news';
                    let valuesForm = {
                        bannerType: res.bannerType,
                        type: res.type,
                        linkType: res.linkType,
                        innerLinkType: res.innerLinkType || 1,
                        linkUrl: res.linkUrl,
                        effectiveStart: res.effectiveStart,
                        effectiveEnd: res.effectiveEnd,
                        endLabel: res.effectiveEnd ? 1 : 0,
                        shopId: res.shopId
                    }
                    if (res.innerLinkType === 1 && res.newsId) {
                        let checkedNews = this.dataSourceNews.find(i => i.id === res.newsId);
                        if (checkedNews) {
                            checkedNews.checked = true;
                        }
                    }
                    if (res.innerLinkType === 2 && res.ticketId) {
                        let checkedTicket = this.dataSourceTicket.find(i => i.ticketTemplateId === res.ticketId);
                        if (checkedTicket) {
                            checkedTicket.checked = true;
                        }
                    }
                    this.$nextTick(() => {
                        this.form.setFieldsValue(
                            valuesForm
                        )
                    })
                });
            },
            onChangeBannerType(e) {
                if(e.target.value == 'header') {
                    this.imgType = 'headerSmall';
                    this.specialText = '尺寸等于1125px*957px';
                }else if(e.target.value == 'banner') {
                    this.imgType = 'bannerSmall';
                    this.specialText = '尺寸等于1029px*576px';
                }
            },
            toPreview() {
                let type = this.form.getFieldValue('bannerType')
                if(type == 'header') {
                    this.imgType = 'headerLager';
                }else if(type == 'banner') {
                    this.imgType = 'bannerLager';
                }
            },

            // 新增
            addBanner(values) {
                this.$api.operation.addBanner({
                    body: values
                }).then(res => {
                    this.$message.success('操作成功', 2);
                    this.$router.go(-1);
                });
            },

            // 编辑
            updateBanner(values) {
                this.$api.operation
                .updateBanner({
                    body: Object.assign(values, {id: this.id})
                })
                .then(res => {
                    this.$message.success('操作成功', 2);
                    this.$router.go(-1);
                });
            },

            uploaded(val) {
                this.imgUrl = val;
            },
            onChange(e) {
                this.linkType = e.target.value;
                this.showTable = 'tickets';
                // this.$nextTick(() => {
                //     this.form.validateFields(['linkUrl'], { force: true });
                // });
            },
            onChangeTable(e) {
                this.showTable = e.target.value == 2 ? 'tickets' : e.target.value == 1 ? 'news' : 'link';
            },
            onChangeTime (e) {
                this.$nextTick(() => {
                    this.form.validateFields(['effectiveStart','effectiveEnd'], { force: true });
                });
            },
            backStep() {
                this.$router.go(-1);
            }
        },
        beforeCreate() {
            this.form = this.$form.createForm(this);
        },
        created() {},
        mounted() {
            this.getListNews()
            this.getListTicket()
            this.getShopList()
            if(this.$route.name !== 'addBanner') {
                this.id = this.$route.query.id;
                setTimeout(() => {
                    this.detailBanner();
                }, 300);
            }
            if(this.$route.name === 'bannerDetail') {
                this.isDisable = true;
            }
        }
    };
</script>
<style lang="scss">
    .addBanner {
        background-color: #fff;
        padding: 24px 32px;
        border-radius: 2px;
        .addBanner-form {
            width: 902px;
            float: left;

            .ant-input-number,
            .ant-calendar-picker {
                width: 100%;
            }
            .avatar-uploader > .ant-upload {
                width: 230px;
                height: 128px;
            }
            .ant-upload-select-picture-card .ant-upload-text {
                margin-top: 8px;
                color: $text-color-black-65;
            }
        }
        .banner-box {
            width: 160px;
            height: 160px;
            background: #FAFAFA;
            border: 1px solid #D9D9D9;
            border-radius: 4px;
            padding: 10px 45px;
            >img {
                width: 70px;
                height: 140px;
            }
        }
    }
</style>
